/**
 * Types and interfaces for the Brass API
 */

// API Response Interfaces
export interface IsMemberOfResponse {
  statusCode: number;
  details: boolean;
}

/**
 * Represents a member of an actor group
 * Maintains original snake_case naming from the backend API
 */
export interface ActorGroupMember {
  group_id: string;
  group_type: string;
}

export interface ListActorGroupsForMemberResponse {
  statusCode: number;
  details: {
    membershipList: ActorGroupMember[];
    next_page: string | null;
  };
}

/**
 * Group type for Brass API requests
 * Values must match the backend API expectations
 */
export enum GroupType {
  TEAM = 'team',
  LDAP_GROUP = 'ldapGroup',
}

/**
 * Result from list operations containing the data and pagination token
 */
export interface ListResult<T> {
  data: T;
  nextPageToken: string | null;
}

/**
 * Result object for membership checks that includes error information
 */
export interface MembershipResult {
  isMember: boolean;
  error?: Error | unknown;
  success: boolean;
}

/**
 * Enhanced result interface that includes error information
 */
export interface ApiResult<T> extends ListResult<T> {
  error?: Error | unknown;
  success: boolean;
}

/**
 * Result interface for all group operations
 */
export interface AllGroupsResult<T> {
  data: T;
  success: boolean;
  error?: Error | unknown;
}
